module.exports = __webpack_public_path__ + "static/media/microphone-stand.a1cb002d.svg";